(ns teamoesterreich.admin-mode.user.user-view

  (:require [clojure.string]
            [goog.date.DateTime]

            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.add :refer [add]]
            [reagent-material-ui.icons.done :refer [done]]
            [reagent-material-ui.icons.healing :refer [healing]]
            [reagent-material-ui.icons.sync :refer [sync]]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.actions :as a]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.data.user :as d-user]
            [teamoesterreich.admin-mode.user.user-card-actions :as card-actions]

            [teamoesterreich.admin-mode.user.user-card-admin :as card-admin]
            [teamoesterreich.admin-mode.user.user-card-devices :as card-devices]
            [teamoesterreich.admin-mode.user.user-card-documents :as card-documents]
            [teamoesterreich.admin-mode.user.user-card-dsg :as card-dsg]
            [teamoesterreich.admin-mode.user.user-card-help-kat :as card-help-kat]
            [teamoesterreich.admin-mode.user.user-card-help-lebensretter :as card-help-lebensretter]
            [teamoesterreich.admin-mode.user.user-card-help-neighbor :as card-help-neighbor]
            [teamoesterreich.admin-mode.user.user-card-help-nokat :as card-help-nokat]
            [teamoesterreich.admin-mode.user.user-card-help-online :as card-help-online]
            [teamoesterreich.admin-mode.user.user-card-help-tafel :as card-help-tafel]
            [teamoesterreich.admin-mode.user.user-card-log :as card-log]
            [teamoesterreich.admin-mode.user.user-card-messages :as card-messages]
            [teamoesterreich.admin-mode.user.user-card-personal :as card-personal]
            [teamoesterreich.element.backend-file :as backend-file]


            [teamoesterreich.setup :as setup]

            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as vstate]

            ))

(def GOOGLE_API (:google-maps-api setup/config))


(defn get-user-details [!actual-user tomId]
  (d-user/get-user-all tomId (fn [data] (reset! !actual-user data)))
  )



(defn get-it []
  (let [!st (r/atom {})
        !tab (r/cursor vstate/app-state [:user-detail :tab])
        !actual-user (r/cursor vstate/app-state [:selected-user])
        !retry-cnt (r/cursor !st [:retry-cnt])
        !tomId (r/cursor vstate/app-state [:path :entityId])
        ]
    (fn []
      (let [
            _ (when (and @!tomId (not (d-user/actual-user-valid? @!tomId !actual-user))) (get-user-details !actual-user @!tomId))
            lat (:addressLatitude @!actual-user)
            lng (:addressLongitude @!actual-user)
            disabled true
            ]
        (js/console.log "user-view get-it -> " @!actual-user)
        (if (or (not= @!tomId (:reqTomId @!actual-user)) (:error @!actual-user))
          ;no data
          [mui/grid
           {:container false :item true
            :md        12                                   ;medium: 960px
            :xs        12                                   ;extra-small: 0px
            :style     {:marginTop "25px"}
            }
           [mui/card
            [mui/card-header
             {:title (str "Personalnummer: " @!tomId)}
             ]
            [mui/card-content
             [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
             [:br]
             [:br]
             [:br]
             [mui/typography "Lade den Datensatz ... "]
             (if (> @!retry-cnt 0)                          ;;retry after some time
               [mui/typography {:color "primary"} (:error @!actual-user) " (" @!retry-cnt ")"]
               (do
                 [mui/typography {:color "primary"} "Versuch (" @!retry-cnt ")"]
                 (js/setTimeout (fn []
                                  (reset! !retry-cnt (inc @!retry-cnt))
                                  (d-user/actual-user-invalidate !actual-user) 2000)
                                )))
             [:br]
             [mui/button
              {:color   "primary"
               :variant "contained"
               :onClick #(swap! vstate/app-state assoc-in [:toe-map :activeUserPopup] nil)
               }
              "Schließen"]
             [mui/button {
                          :style   {:margin-left "40px"}
                          :endIcon (r/as-element [sync])
                          :onClick #(d-user/actual-user-invalidate !actual-user)
                          } "Neu laden"]

             ]]]
          ;has data
          [mui/grid
           {:container false :item true
            :xl        10
            :md        12                                   ;medium: 960px
            :xs        12                                   ;extra-small: 0px
            :style     {:marginTop "25px"}
            }
           [mui/card {:style {:textAlign "left"}}

            [mui/card-header
             {:title    (r/as-element [:<>
                                       (str @!tomId ") " (:user-title @!actual-user) " " (:user-firstName @!actual-user) " " (:user-lastName @!actual-user))
                                       [:br]
                                       [mui/typography {:variant "caption"}
                                        "FB-ID: " (:user-userId @!actual-user)]])
              :subtitle (str "Personalnummer: " @!tomId)}
             ]

            [mui/card-content
             {:style {:maxWidth "1300px"}}
             [mui/grid
              {:container  true
               :direction  "row"
               :justify    "space-around"
               :alignItems "flex-start"
               :spacing    3
               }

              [mui/grid
               {:container false :item true
                :md        6                                ;medium: 960px
                :xs        12                               ;extra-small: 0px
                }
               (if (and (:user-portraitFileHash @!actual-user) (not= "" (:user-portraitFileHash @!actual-user)))
                 [backend-file/img {:hash     (:user-portraitFileHash @!actual-user)
                                    :preview? false
                                    :height   "200"
                                    :style    {:object-fit "contain" :width "100%"}
                                    :title    (str (:user-firstName @!actual-user) " " (:user-lastName @!actual-user))
                                    :alt      (str (:user-firstName @!actual-user) " " (:user-lastName @!actual-user))}]
                 [:img {:src    "/custom/img/placeholder-md.png"
                        :height "200"
                        :style  {:object-fit "contain" :width "100%"}
                        :title  (str (:user-firstName @!actual-user) " " (:user-lastName @!actual-user))
                        :alt    (str (:user-firstName @!actual-user) " " (:user-lastName @!actual-user))
                        }]
                 )]

              [mui/grid
               {:container false :item true
                :md        6                                ;medium: 960px
                :xs        12                               ;extra-small: 0px
                }
               [:img
                {:src    (if (and lat lng)
                           (str "https://maps.googleapis.com/maps/api/staticmap?"
                                "center=" lat "," lng "&zoom=12&size=1000x200&"
                                "markers=color:red|" lat "," lng
                                "&key=" GOOGLE_API "&"
                                )
                           "/custom/img/home.png")
                 :height "180"
                 :style  {:object-fit "cover" :width "100%"}
                 :title  (str (:user-address @!actual-user))
                 :alt    (str (:user-address @!actual-user))
                 }]]
              ]]
            [mui/card-actions
             [mui/button {
                          :endIcon (r/as-element [sync])
                          :onClick #(d-user/actual-user-invalidate !actual-user)
                          } "Neu laden"]

             [mui/button {
                          :endIcon (r/as-element [add])
                          :onClick (fn [] (a/add-to-selection [@!tomId]))
                          } "In die Auswahl"]


             (when (:user-helpingLebensretter @!actual-user)
               [mui/button {:startIcon (r/as-element [healing])
                            :onClick   (fn []
                                         (swap! vstate/app-state assoc-in [:lr-list :selected-toe] @!tomId)
                                         (a/open-lr-user-view @!tomId))
                            } "Lebensretter"])

             (if (:user-hdyValid @!actual-user)
               [mui/chip {
                          :color      "secondary"
                          :deleteIcon (r/as-element [done])
                          :label      "Mobilnummer bestätigt"
                          }]
               [mui/chip {
                          :color "primary"
                          :label "Mobilnummer nicht bestätigt"
                          }])
             (if (:user-emailValid @!actual-user)
               [mui/chip {
                          :color      "secondary"
                          :deleteIcon (r/as-element [done])
                          :label      "Email bestätigt"
                          }]
               [mui/chip {
                          :color "primary"
                          :label "Email nicht bestätigt"
                          }])
             (if (:user-identityValid @!actual-user)
               [mui/chip {
                          :color      "secondary"
                          :deleteIcon (r/as-element [done])
                          :label      "Identität bestätigt"
                          }]
               [mui/chip {
                          :color "primary"
                          :label "Identität nicht bestätigt"
                          }])

             (if (:user-profileValid @!actual-user)
               [mui/chip {
                          :color      "secondary"
                          :deleteIcon (r/as-element [done])
                          :label      "Profil vollständig"
                          }]
               [mui/chip {
                          :color "primary"
                          :label (str "Profil unvollständig : " (:user-profileValidHint @!actual-user))
                          }]
               )
             ]
            ]
           [mui/card {:style {:backgroundColor "#e6e6e6" :padding "5px" :marginTop "10px"}}

            [mui/card-content {}
             (log/debug "Open Tab " @!tab)
             [mui/tabs {:value          (or @!tab 0)
                        :onChange       (fn [x i y] (log/debug "set tab " x i y) (reset! !tab i))
                        :indicatorColor "primary"
                        :textColor      "primary"
                        :variant        "scrollable"
                        }
              [mui/tab {:value 0 :label "Details"}]
              [mui/tab {:value 1 :label "Helfen"}]
              [mui/tab {:value 2 :label "Nachrichten"}]
              [mui/tab {:value 3 :label "Mobilgeräte"}]
              [mui/tab {:value 4 :label "Verlauf"}]
              [mui/tab {:value 5 :label "DsgVo"}]

              ;(when (d-rights/allow-admin-for d-rights/USER (:user-orgId @!actual-user)) [mui/tab {:value 9 :label "Admin"}])

              (when (d-rights/allow-admin-for d-rights/ADMIN (:user-orgId @!actual-user)) [mui/tab {:value 9 :label "Berechtigungen"}])

              ]

             [:br]
             (case @!tab

               1 [:div
                  [card-help-lebensretter/get-it !actual-user]
                  [:br]
                  [card-help-kat/get-it !actual-user]
                  [:br]
                  [card-help-nokat/get-it !actual-user]
                  [:br]
                  [card-help-online/get-it !actual-user]
                  [:br]
                  [card-help-neighbor/get-it !actual-user]
                  (when (txt/txt :fake :tafel) [:br])
                  (when (txt/txt :fake :tafel) [card-help-tafel/get-it !actual-user])
                  ]
               2 [:div
                  [card-messages/get-it !actual-user !st]
                  ]
               3 [:div
                  [card-devices/get-it !actual-user !st]
                  ]
               4 [:div
                  [card-log/get-it !actual-user !st]
                  ]
               5 [:div
                  [card-dsg/get-it !actual-user !st]
                  ]
               9 [:div
                  [card-admin/get-it !actual-user !st]
                  ]

               [:div
                (when (d-rights/allow-admin-for d-rights/USER (:user-orgId @!actual-user)) [card-actions/get-it !actual-user !st])
                [:br]
                [card-personal/get-it !actual-user !st]
                [:br]
                [(card-documents/get-it !actual-user)]
                ]
               )

             ]]]
          )))))
